import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { motion } from 'framer-motion';
import CounterAnimation from '../components/CounterAnimation';
import '../css/Home.css';
import PLC from '../assets/images/plc-1200.webp';
import LogosClientes from '../json/LogosClientes.json'
import LogoIdk from '../assets/images/logoIdk.webp';
import TableroGrande from '../assets/images/tableros-electricos-instalacion.webp';
import TableroChico from '../assets/images/tablero-chico.webp';
import Ingenieria from '../assets/images/proyectos_electricos.webp'
import Tablero from '../assets/images/tablero-bph.webp'
import Mantenimiento from '../assets/images/electri-1611612488.webp'
import Instalaciones from '../assets/images/instalaciones.webp'
import Termografia from '../assets/images/servicios/camara-termografica.webp'
import Capacitacion from '../assets/images/capacitacion.webp'

const getClienteLogo = (filename) =>
    require(`../assets/images/clientes/${filename}`);

const HERO_SLIDES = [
    { src: PLC, alt: 'PLC', priority: true },
    { src: TableroGrande, alt: 'Medición tablero' },
    { src: TableroChico, alt: 'Tablero térmicas' },
];

const Home = () => {
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            setActiveSlide((index) => (index + 1) % HERO_SLIDES.length);
        }, 6000);
        return () => clearInterval(id);
    }, []);

    return (
        <>
            <main className='container-fluid p-0'>
                <section className='position-relative'>
                    <div id="carouselExampleFade" className="carousel slide carousel-fade">
                        <div className="carousel-inner">
                            {HERO_SLIDES.map((slide, index) => (
                                <div key={index} className={`carousel-item${index === activeSlide ? ' active' : ''}`}>
                                    <img src={slide.src} className="d-block w-100 carousel-zoom-img" alt={slide.alt} fetchpriority={slide.priority ? 'high' : 'low'} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <motion.div className='logo-hero'>
                        <LazyLoadImage
                            src={LogoIdk}
                            className='img-fluid'
                            alt='Logo Idelek'
                            fetchpriority='low'
                        />
                    </motion.div>
                </section>

                <section className='quienes-somos'>
                    <div className='container'>
                        <motion.div
                            className='text-center mb-5'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <p className='hero-tagline'>
                                Creamos soluciones electrónicas y eléctricas en baja tensión para la industria
                            </p>
                            <h2 className='section-title'>Quienes Somos</h2>
                            <div className='title-underline'></div>
                        </motion.div>

                        <motion.div
                            className='stats-band'
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className='stat-pillar'>
                                <div className='stat-icon'>
                                    <i className="bi bi-award"></i>
                                </div>
                                <h3 className='stat-number'>
                                    <CounterAnimation end={30} prefix="+" />
                                </h3>
                                <p>Años de experiencia</p>
                            </div>
                            <div className='stat-pillar'>
                                <div className='stat-icon'>
                                    <i className="bi bi-people"></i>
                                </div>
                                <h3 className='stat-number'>
                                    <CounterAnimation end={30} prefix="+" />
                                </h3>
                                <p>Clientes</p>
                            </div>
                            <div className='stat-pillar'>
                                <div className='stat-icon'>
                                    <i className="bi bi-briefcase"></i>
                                </div>
                                <h3 className='stat-number'>
                                    <CounterAnimation end={100} prefix="+" />
                                </h3>
                                <p>Proyectos completados</p>
                            </div>
                            <div className='stat-pillar'>
                                <div className='stat-icon'>
                                    <i className="bi bi-grid-1x2"></i>
                                </div>
                                <h3 className='stat-number'>
                                    <CounterAnimation end={6} />
                                </h3>
                                <p>Servicios especializados</p>
                            </div>
                        </motion.div>

                        <motion.div
                            className='quienes-text'
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.15 }}
                        >
                            <p className='lead-text'>
                                Somos una empresa de prestación de servicios con <strong>más de 30 años de experiencia</strong> en el gremio de electricidad y electrónica industrial.
                            </p>
                            <p>
                                Una evolución permanente en la confección de anteproyectos y <strong>proyectos de ingeniería</strong>, el diseño y armado de tableros eléctricos, ejecución de obras y montajes de nuevas instalaciones y mantenimiento de las existentes.
                            </p>
                            <p>
                                Cada cliente es único, como lo es el proyecto que requiere, por lo tanto, es nuestro principal objetivo satisfacer todas las necesidades de nuestros clientes <strong>en calidad, precio y tiempos adecuados</strong>.
                            </p>
                            <Link className='btn-primary mt-4' to='/contacto'>
                                Contáctanos
                            </Link>
                        </motion.div>
                    </div>
                </section>

                <section className='process-section' id='servicios'>
                    <div className='container'>
                        <motion.div
                            className='text-center mb-5'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <h2 className='section-title'>Cómo Trabajamos</h2>
                            <div className='title-underline'></div>
                        </motion.div>

                        <div className='process-timeline'>
                            <motion.div
                                className="process-step"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.1 }}
                            >
                                <div className="process-step-number">01</div>
                                <h3 className="process-title">Su Idea</h3>
                                <p className="process-text">
                                    Coméntenos su idea, inconveniente o inquietud sobre instalaciones y/o máquinas nuevas o existentes
                                </p>
                            </motion.div>

                            <motion.div
                                className="process-step"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.3 }}
                            >
                                <div className="process-step-number">02</div>
                                <h3 className="process-title">Nuestra Propuesta</h3>
                                <p className="process-text">
                                    Le realizaremos una propuesta sobre el problema mencionado, con la cotización correspondiente
                                </p>
                            </motion.div>

                            <motion.div
                                className="process-step"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.5 }}
                            >
                                <div className="process-step-number">03</div>
                                <h3 className="process-title">Ejecución</h3>
                                <p className="process-text">
                                    Realizamos el trabajo con herramientas y personal de calidad, dejando el inconveniente solucionado
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </section>

                <section className="services-grid">
                    <div className="container">
                        <motion.div
                            className='text-center mb-5'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <h2 className='section-title'>Nuestros Servicios</h2>
                            <div className='title-underline'></div>
                        </motion.div>

                        <div className="row g-4">
                            <div className="col-lg-4 col-md-6">
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 0.1 }}
                                >
                                    <Link to="/ingenieria" className="service-card">
                                        <div className="service-image">
                                            <img src={Ingenieria} alt="Ingeniería" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="service-title">Ingeniería y proyectos</h3>
                                            <p className="service-description">
                                                Diseño, implementación y dirección de redes de baja tensión, sistemas de control y automatización.
                                            </p>
                                        </div>
                                    </Link>
                                </motion.div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 0.2 }}
                                >
                                    <Link to="/tableros" className="service-card">
                                        <div className="service-image">
                                            <img src={Tablero} alt="Tableros" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="service-title">Tableros eléctricos</h3>
                                            <p className="service-description">
                                                Construcción de TGBT, corrector de Coseno de Phi "φ", de distribución, de control de potencia, y más.
                                            </p>
                                        </div>
                                    </Link>
                                </motion.div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 0.3 }}
                                >
                                    <Link to="/termografia" className="service-card">
                                        <div className="service-image">
                                            <img src={Termografia} alt="Termografía" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="service-title">Termografía y mediciones</h3>
                                            <p className="service-description">
                                                Estudio termográfico sobre instalaciones, mediciones de redes, puesta tierra y disyuntores diferenciales.
                                            </p>
                                        </div>
                                    </Link>
                                </motion.div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 0.4 }}
                                >
                                    <Link to="/mantenimiento" className="service-card">
                                        <div className="service-image">
                                            <img src={Mantenimiento} alt="Mantenimiento" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="service-title">Mantenimiento industrial</h3>
                                            <p className="service-description">
                                                Control, intervención y modificación sobre máquinas y/o instalaciones ya existentes.
                                            </p>
                                        </div>
                                    </Link>
                                </motion.div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 0.5 }}
                                >
                                    <Link to="/instalaciones" className="service-card">
                                        <div className="service-image">
                                            <img src={Instalaciones} alt="Instalaciones" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="service-title">Instalaciones</h3>
                                            <p className="service-description">
                                                Relevamiento, análisis y ejecución sobre el sector donde se desea implementar soluciones eléctricas y electrónicas.
                                            </p>
                                        </div>
                                    </Link>
                                </motion.div>
                            </div>

                            <div className="col-lg-4 col-md-6">
                                <motion.div
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.6, delay: 0.6 }}
                                >
                                    <Link to="/capacitacion" className="service-card">
                                        <div className="service-image">
                                            <img src={Capacitacion} alt="Capacitación" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="service-title">Capacitación eléctrica industrial</h3>
                                            <p className="service-description">
                                                Brindamos capacitaciones referidas a cuidados, recomendaciones y normas a cumplir en el ámbito eléctrico industrial.
                                            </p>
                                        </div>
                                    </Link>
                                </motion.div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='whatsapp-cta'>
                    <div className='wa-cta-bg'></div>
                    <div className='container text-center wa-cta-inner'>
                        <div className='wa-icon-wrapper'>
                            <i className="bi bi-whatsapp wa-main-icon"></i>
                        </div>
                        <p className='cta-text'>¿Tenés alguna consulta?</p>
                        <p className='cta-subtext'>Escribinos directamente por WhatsApp y te respondemos a la brevedad</p>
                        <a className='botonWhatsApp' href="https://api.whatsapp.com/send?phone=5493515165848" target="_blank" rel="noreferrer">
                            <i className="bi bi-whatsapp"></i>
                            Contactar por WhatsApp
                        </a>
                    </div>
                </section>

                <section className='clientes-section'>
                    <div className='container'>
                        <motion.div
                            className='text-center mb-5'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <h2 className='section-title'>Clientes</h2>
                            <div className='title-underline'></div>
                        </motion.div>
                        <div className="clientes-marquee" aria-label="Nuestros clientes">
                            <div className="logos-track">
                                {[...LogosClientes, ...LogosClientes].map((result, index) => (
                                    <div className="logo-item" key={index}>
                                        <img src={getClienteLogo(result.img)} alt={result.title} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}

export default Home;